<div class="container vh-100 flex justify-content-center align-items-center">
  <div class="text-center page404">
    <h1>404</h1>
    <p>questa pagina non &egrave; stata trovata</p>
    <a class="btn btn-success btn-md" href="#/auth">{{
      'connections_page.back_home' | translate
    }}</a>
  </div>
</div>
